const RequestSignatureConstants = {
  RECIPIENT_SIGNATURE_ENABLE: 'RECIPIENT_SIGNATURE_ENABLE',
  TERMS_OF_SERVICE_ERROR_SHOW: 'TERMS_OF_SERVICE_ERROR_SHOW',
  SIGNATURE_DECLINE_TOOLBAR_SHOW: 'SIGNATURE_DECLINE_TOOLBAR_SHOW',
};

export default RequestSignatureConstants;



// WEBPACK FOOTER //
// ./src-react/Popups/RequestSignaturePopupWrapper/RequestSignatureConstants.jsx